import { IdentificacaoEquipamentoView } from "./view-identificacao-equipamento";
import type { IdentificacaoEquipamentoProps } from "./types-identificacao-equipamento";

export function IdentificacaoEquipamento(props: IdentificacaoEquipamentoProps) {
  return <IdentificacaoEquipamentoView {...props} />;
}

export type * from "./types-identificacao-equipamento";
